import {
  WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE,
  WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW,
  WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED,
  WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE,
} from '../action-types';
import { quotesApi } from '../../../../services/api/quotes-api';
import { showErrorMessage } from '../../../messages';
import { updateQuotes } from './details';
import { push } from 'react-router-redux';
import { baseRoutePath } from '../work-orders';

export function closeDenyQuoteModal() {
  return {
    type: WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_CLOSE,
  };
}

export function changeReason(value) {
  return {
    type: WORK_ORDERS_DETAILS_DENY_QUOTE_REASON_CHANGE,
    payload: value,
  };
}

export function denyQuoteRequest(quoteId, reason) {
  return (dispatch) => {
    return quotesApi
      .denyQuote(quoteId, reason !== '' ? reason : undefined)
      .then((response) => {
        if (response.ok) {
          dispatch(updateQuotes([response.quote]));
          dispatch(closeDenyQuoteModal());
          dispatch(push(baseRoutePath));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function selectAnswer(value) {
  return {
    type: WORK_ORDERS_DETAILS_DENY_QUOTE_QUESTION_ANSWERED,
    payload: value === 'yes',
  };
}

export function showDenyQuoteModal() {
  return {
    type: WORK_ORDERS_DETAILS_DENY_QUOTE_MODAL_SHOW,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/deny-quote.js